import { defaultOptions } from "../Options.js";
/**
 * Utility function that allows to filter files from a FileCollection ignores by default the dotFiles
 * @param relativePath - The relative path of the file to check
 * @param options - the filter options to use
 * @returns boolean
 */
export function shouldAddItem(relativePath, options = {}) {
    const { ignoreDotfiles = defaultOptions.filter.ignoreDotfiles } = options;
    if (!ignoreDotfiles)
        return true;
    if (relativePath.startsWith('.'))
        return false;
    if (relativePath.includes('/.'))
        return false;
    return true;
}
//# sourceMappingURL=shouldAddItem.js.map